import React, { HTMLAttributes } from 'react';

import styles from '../styles.module.css';

export interface CardAppointmentBadgeProps
  extends HTMLAttributes<HTMLDivElement> {}

export const CardAppointmentBadge: React.FC<CardAppointmentBadgeProps> = ({
  children,
  ...props
}) => {
  return (
    <span className={styles.cardBadge} {...props}>
      {children}
    </span>
  );
};
